module.exports = __webpack_public_path__ + "img/WP2023-CallForFS.bbe70262.jpg";